import {useContext, useEffect} from "react";
import {CostHelperContext} from "../project/shopdrawing/pricing/CostHelperContext";
import {useSyncedRef} from "../../misc/SyncedRef";
import {PriceLookupItem} from "./PriceLookup";
import {EditContext} from "../../misc/scroller/EditProvider";

export function CostFocuser(props: {
    anchorEl: any;
    row: PriceLookupItem;
}) {
    const {show} = useContext(CostHelperContext);
    const edit = useContext(EditContext)
    const editRef = useSyncedRef(edit);

    useEffect(() => {
        const valueOriginal = props.row;

        return show(props.row, (value) => {
            const update: Partial<PriceLookupItem> = {
                unitPrice: value.avgUnitCostCents,
                updatedAt: new Date().toISOString(),
            }

            editRef.current.update(Object.assign({}, props.row, {
                value: Object.assign({}, valueOriginal, update)
            }));

            editRef.current.onSelect.emit(null);
        });
    }, [show, props.row, editRef])

    return null;
}